import { notification } from 'antd'
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import PageLayout from '../Layout/PageLayout';
import CreateForm from './CreateForm';
import {
    noAuthCreateClientWithUser,
    createClientWithUser,
} from '../../utils/apiBucherVaslin';
import history from '../../history';

const sitekey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const save = (locale, loggedIn, intl) => async (values) => {

    if (!window.grecaptcha) {
        throw new Error("reCAPTCHA non chargé");
    }

    const formatedValues = { ...values };
    if (formatedValues.client.fichiers) {
        formatedValues.client.fichiers = values.client.fichiers.fileList.map((f) => f.originFileObj);
        if (1 === formatedValues.client.fichiers.length) {
            formatedValues.client.fichiers = formatedValues.client.fichiers.shift();
        }
    }
    formatedValues.client.codeLangue = locale;

    const token = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
            try {
                window.grecaptcha.execute(
                    sitekey,
                    {
                        action: 'create_client'
                    }
                ).then(resolve, reject);
            } catch (error) {
                reject(error);
            }
        });
    });

    formatedValues.recaptchaToken = token;

    const result = await (loggedIn
        ? createClientWithUser
        : noAuthCreateClientWithUser
    )(formatedValues);

    if (result.isSuccess) {
        return history.goBack();
    }

    notification.error({
        message: result.isUnauthorized
            ? intl.formatMessage({ id: 'error.unauthorized.title' })
            : intl.formatMessage({ id: 'common.error' }),
        description: result.isUnauthorized
            ? intl.formatMessage({ id: 'error.unauthorized.message' })
            : result.errorDetail,
    });

    return result;
};

const ClientCreate = ({ locale, loggedIn, intl }) => (
    <PageLayout pageKey="newCustomer">
        <h2>
            <FormattedMessage
                id="client.create.title"
                defaultMessage="Create a new client"
            />
        </h2>
        <CreateForm save={save(locale, loggedIn, intl)} loggedIn={loggedIn} pageKey="newCustomer"/>
    </PageLayout>
);

ClientCreate.propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    locale: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
};

const mapStateToProps = ({
    signIn: {
        loggedIn,
    },
    app: {
        locale,
    },
}) => ({ locale, loggedIn });

export default injectIntl(connect(mapStateToProps, {})(ClientCreate));
